import React from "react";
import { Row, Col } from "antd";
import { useIntl } from "react-intl";
import FeatureCard from "./FeatureCard";
import { useRecState } from "../../Orchestrator/Recoils/Events/Recoil";
import { ICmsEnhancedTrips } from "../../Orchestrator/Types/Interface/ICmsEnhancedTrip";
import { _eventBus } from "../../core/events/EventBus";
import { evtTree } from "../../Orchestrator/ConstantTree";
import { rememberBackPath, BACK_PATH_KEYS } from "../../Lib/Utils/backNavigation";
import "./EnhanceYourTrip.css";

const EnhanceYourTrip: React.FC = () => {
  const intl = useIntl();

  const [enhancedTrips] = useRecState<ICmsEnhancedTrips[]>("enhancedTripsResponseAtom");
  const onCardClick = (slug: string) => {
    if (slug && slug != "") {
      rememberBackPath(BACK_PATH_KEYS.enhancedTrips);
      _eventBus.emit({
        eventName: evtTree.enhancedTrips.Details.Click,
        data: { slug }
      });
    }
  }
  return (
    <div className="enhance_main">
      <div>
        <div className="pageTitle">
          <h2>{intl.formatMessage({ id: "EnhanceYourTrip" })}</h2>
          <h6 className="sub-title">{intl.formatMessage({ id: "EnhanceYourTripLoverCase" })}</h6>
        </div>
        <Row gutter={[20, 20]} align={"stretch"} justify="center">
          {enhancedTrips
            .filter((feature) => feature?.image?.url)
            .map((feature, index) => (
              <Col
                key={index}
                className="text-center cursor-pointer"
                md={{ flex: "25%" }}
                sm={{ flex: "50%" }}
                xs={{ flex: "100%" }}
                onClick={() => { onCardClick(feature.slug) }}
              >
                <FeatureCard imageSrc={feature.image.url} title={feature.title} />
              </Col>
            ))}
        </Row>
      </div>
    </div>
  );
};

export default EnhanceYourTrip;
